/*
  The two things a surface says when it has nothing to show.

  LOADING WAS THE WEAK ONE.

  *This paragraph originally claimed "five loading indicators across roughly fifteen fetching
  surfaces… the other ten showing nothing at all". Re-measured at P9f-c, that was wrong and inflated.
  The client has SIX panels that call the API and four store-level fetches; the fetch-on-open
  surfaces are the proposals list, the member list, the user list, the history and its restore
  points, plus the boot and the design load. Nine or ten, not fifteen — and every one of them did say
  something. The estimate was written from an impression rather than a count, which is the failure
  this file's own comments criticise elsewhere.*

  What WAS true, and is what this primitive fixes: all five indicators were a bare `Loading…` in a
  `<p className="muted">`, with no `role="status"` and no `aria-live`. So a screen-reader user got no
  announcement when a fetch started and none when it finished — the modal simply went quiet and then
  had content in it. They also all said the same three characters, which tells a reader nothing about
  which of two concurrent requests they are waiting on.

  EMPTY WAS THE STRONG ONE and is preserved rather than replaced. This client's empty states are
  genuinely well written — "Just you right now.", "Changes from anyone on the project appear here." —
  and the point of a primitive here is not to standardise the words but to stop the NEXT one being
  "No data". So `Empty` takes a sentence and refuses to supply a default: there is no generic empty
  state, because the useful part is always specific to what is missing and why.
*/

export function Loading({
  what,
  testId,
}: {
  /** What is being fetched, in the reader's terms. "the members", not "data". */
  what: string;
  testId?: string;
}): JSX.Element {
  return (
    <p className="muted" data-testid={testId} role="status" aria-live="polite">
      Loading {what}…
    </p>
  );
}

export function Empty({
  children,
  testId,
}: {
  /*
    A sentence, required. No default, on purpose.

    Every generic empty state in every product says a version of "Nothing here", which tells the
    reader what they can already see. What they need is why it is empty and what would fill it, and
    only the caller knows that.
  */
  children: React.ReactNode;
  testId?: string;
}): JSX.Element {
  return (
    <p className="muted" data-testid={testId}>
      {children}
    </p>
  );
}
